export default __webpack_public_path__ + "static/media/sonik_rooftop.bb2af747.jpg";